<template>
  <div class="ts-mb-2">
    <div>
      <a-radio-group
        name="radioGroup"
        default-value="USD"
        v-model="model.currency"
      >
        <a-radio value="USD">
          USD
        </a-radio>
        <a-radio value="KHR">
          KHR
        </a-radio>
        <a-radio value="THB">
          THB
        </a-radio>
      </a-radio-group>
    </div>
    <div class="ts-border ts-rounded-md ts-mt-2 ts-p-3">
      <p class="ts-mb-0">Paper Size</p>
      <div>
        <a-radio-group
          name="paperSize"
          default-value="a5"
          v-model="model.paperSize"
        >
          <a-radio value="a5">
            A5
          </a-radio>
          <a-radio value="a4">
            A4
          </a-radio>
          <a-radio value="e_receipt">
            Receipt
          </a-radio>
        </a-radio-group>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['value'],
  data() {
    return {
      model: {}
    }
  },
  created() {
    this.model = this.value
  }
}
</script>
